module.exports = __webpack_public_path__ + "img/order.1056b880.png";